import * as yup from 'yup'

type Translate = (key: string, options?: object) => string

export default (t: Translate) =>
  yup
    .string()
    .required('此為必填欄位')
    .matches(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]){8,10}$/, t('login1'))
